let order_SubItem = require("../../templates/order/SubItem.handlebars");
let $ = require('jquery');
let _ = require("underscore");
let Backbone = require("backbone");
let POS = require("../../POS.js");
let MenuTagCollection = require("../../collection/MenuTagCollection.js");
let MenuTagModel = require("../../model/MenuTagModel.js");
let DiscountCollection = require("../../collection/DiscountCollection.js");

let main = function () {
    return Backbone.View.extend({
        events: {
            'click .closeBillItemEdit': "onClose",
            'click .sub-item': "switchItem",
            'mousedown .sub-item': "toggleSubItem",
            'mouseup .sub-item': "toggleSubItem"
        },

        initialize: function () {
        },


        onClose: function () {
            this.trigger("close");
        },

        toggleSubItem:function(evt){
            $(evt.currentTarget).toggleClass("selected");
        },

        render: function () {
            this.$el.append(order_SubItem({subitems: this.model}));
            return this;
        },

        /**
         * 选择餐品
         */
        switchItem: function (evt) {
            var selectItem = $(evt.currentTarget),
                self = this;
            if(selectItem.find('.pull-left').hasClass('sold-out')){
                alert('此菜品暂时停售');
                return;
            }
            self.trigger("selectSubItem", {id:selectItem.data('id'),name:selectItem.data('name'),cid:selectItem.data('cid'),price:selectItem.data('price')});
        }
    });

};

let exportedValue = main();

module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/order/SubItemView.js